import React, {useEffect} from 'react';
import {Button, Card, Space, Typography} from "antd";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {Icon, validatePath} from "../../common/layout/mapper/Layout";
import {setActions, setHeader} from "../../redux/actions/layout/interaction/action";
import {UnorderedListOutlined} from "@ant-design/icons";

const {Title, Text} = Typography;

const Setting = props => {
    const dispatch = useDispatch()
    const {t} = useTranslation()
    let navigate = useNavigate()

    const {settingSider} = useSelector(state => state.layoutDataReducer)

    useEffect(() => {
        dispatch(setHeader(t("setting.title"), null))
        dispatch(setActions(null))
    }, [])

    const getButtons = (values, parentPath) => {
        return <Space align="center" size={"large"}>
            {values?.map(value => {
                    if (value.name === "work")
                        return <Space direction="vertical" align="center" style={{marginRight: "80px"}}>
                            <Button
                                disabled={value.enabled === false}
                                size={"large"}
                                type="text"
                                onClick={() => {
                                    navigate(validatePath(parentPath) + validatePath(getFirstPath(validatePath(value.path))))
                                }}
                                icon={value.icon !== "" ?
                                    <Icon iconName={value.icon}/> :
                                    <UnorderedListOutlined/>}
                            />
                            <Text disabled={value.enabled === false}>{t(`layout.${value.name}`)}</Text>
                        </Space>
                }
            )}
        </Space>
    }
    const getFirstPath = (value) => {
        const childs = settingSider.childs.find(element => {
            return validatePath(element.path) === value
        })?.childs
        let to = validatePath(value?.path)
        for (const element of childs) {
            if (!element?.enabled === false) {
                const first = element
                to = to + validatePath(first?.path)
                if (first?.childs?.length > 0)
                    to = to + validatePath(first?.childs[0]?.path)
                break;
            }
        }
        return validatePath(value) + to
    }

    return (
        <>
            <Card type="inner" title={<Title level={4}>System</Title>} style={{marginTop: "16px"}}>
                {getButtons(settingSider?.childs, "/setting")}
                <Space direction="vertical" align="center" style={{marginRight: "80px"}}>
                    <Button
                        size={"large"}
                        type="text"
                        onClick={() => {
                            navigate("/shortcut/employee")
                        }}
                        icon={<UnorderedListOutlined/>}
                    />
                    <Text>{t("tnp.components.timekeeping.text56")}</Text>
                </Space>
            </Card>
        </>
    );
};

Setting.propTypes = {};

export default Setting;
